import styles from './UnavailableScreen.module.css';

/** Shown when a route is hidden in the AgriTour public slice. */
export default function UnavailableScreen() {
  return (
    <div className={styles.page} dir="rtl" lang="he">
      <main className={styles.main}>
        <p className={styles.code} aria-hidden>
          404
        </p>
        <h1 className={styles.title}>הדף אינו זמין</h1>
        <p className={styles.body}>
          הקישור שביקשת אינו פעיל כרגע. אם הגעתם לכאן בטעות, חזרו לטופס הקול הקורא.
        </p>
        <a className={styles.link} href="/questionnaire">
          לטופס הקול הקורא
        </a>
      </main>
    </div>
  );
}
